import { Injectable } from '@angular/core';
import { GtmTracking } from '../../lib/services/gtm.service';
import { ValidationsService } from '@evermile/api';
import { parsePhoneNumber, getCountries, getCountryCallingCode, CountryCode } from 'libphonenumber-js';

export interface DropDownCountry {
  code?: CountryCode;
  name?: string;
  flagClass: string;
  phonePrefix?: string;
  placeHolder?: string;
}
@Injectable({
  providedIn: 'root',
})
export class PhoneUtils {
  countriesData?: DropDownCountry[];
  flagsExceptions: any = {
    ac: 'sh-ac',
  };

  constructor(
    private gtmTracking: GtmTracking,
    private apiValidationService: ValidationsService,
  ) {}

  validatePhoneNumberFromServer(phoneNumber: string) {
    return this.apiValidationService.phoneValidateGet(phoneNumber);
  }

  // removePrefix(phoneNumber:string ='') {
  //     if (phoneNumber.startsWith("+44")) {
  //         phoneNumber = phoneNumber.substring(3)
  //     }
  //     return phoneNumber.replaceAll('-', '');
  // }

  getAllCountriesData() {
    if (this.countriesData) return this.countriesData;
    this.setCountriesData();
    return this.countriesData;
  }

  setCountriesData() {
    this.countriesData = [];
    const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
    const countriesIsoCodes = getCountries();
    countriesIsoCodes.forEach((code) => {
      const singleCountryDataObject: DropDownCountry = {
        code,
        name: regionNames.of(code) || '',
        flagClass: this.getExceptionFlag(code.toLowerCase()) || `fi fi-${code.toLowerCase()}`,
        phonePrefix: '+' + getCountryCallingCode(code),
      };
      if (code === 'GB') {
        this.countriesData!.unshift(singleCountryDataObject);
        return;
      }
      this.countriesData?.push(singleCountryDataObject);
    });
  }

  getExceptionFlag(code?: string) {
    if (!code) return;
    if (Object.keys(this.flagsExceptions).includes(code)) {
      return 'fi fi-' + this.flagsExceptions[code];
    }
    return;
  }

  getFlagClass(number: string) {
    if (!number) return;
    try {
      const code = parsePhoneNumber(number)?.country?.toLowerCase();
      return `fi fi-${code}`;
    } catch (e) {
      console.log(e);
      return;
    }
  }
}
